import { Link } from "react-router-dom";

/**
 * A line for a person who has never visited before: Getting started shows them around, with a practice space, and nothing
 * forces them there (ui-direction, screen 1; UI-12). It is optional, and it stays out of the way of a returning person.
 */
export function GettingStartedNote() {
  return (
    <p className="nv-welcome__first">
      You are new here. <Link to="/onboarding">Getting started</Link> shows you around in a few short modules, with a practice space. It is optional, and you can come back to it any time.
    </p>
  );
}
